module.exports = __webpack_public_path__ + "images/category_lp/brand/new/assessment_achievements/6@2x_506f0e01a36a452e9cbb6ca693949e5e.png";